<template>
  <div class="extended-search-block">
    <div class="extended-search-block__title">
      <h2>
        {{ header }}
      </h2>
    </div>

    <div class="extended-search-block__search">
      <a-popover
          v-model:open="filtersPopoverOpen"
          trigger="click"
          placement="bottom"
          overlay-class-name="filters-popover"
      >
        <a-input
            class="header-search-popover"
            v-model:value="currentFiltersLine"
            readonly
            placeholder="Поиск + фильтр"
            @click="openFilterModal = true"
        >
          <template #suffix>
            <SearchOutlined style="color: rgba(0, 0, 0, 0.45)" />
          </template>
        </a-input>

        <template #content>
          <UserFilterForm
              v-if="type === 'staff'"
              :currentGroupId="currentGroupId"
              @close="() => {
                openFilterModal = false;
                filtersPopoverOpen = false;
              }"
          />

          <SmallUsersFilter
              v-else-if="type === 'order'"
              @close="() => {
                openFilterModal = false;
                filtersPopoverOpen = false;
              }"
          />

          <ReferenceProfileUserFilterForm
              v-else-if="type === 'referenceSmall'"
              @close="() => {
                openFilterModal = false;
                filtersPopoverOpen = false;
              }"
          />

          <GroupFilterForm
              v-else
              @close="() => {
                openFilterModal = false;
                filtersPopoverOpen = false;
              }"
          />
        </template>

        <template #title>
          <span>Поиск + Фильтр</span>
        </template>
      </a-popover>
    </div>

    <ReloadOutlined
        v-if="currentFiltersLine"
        class="extended-search-block__reset"
        @click="resetFilters"
        style="color: rgba(0, 0, 0, 0.45)"
    />
  </div>
</template>

<script>
import {ReloadOutlined, SearchOutlined} from "@ant-design/icons-vue";
import UserFilterForm from "@/feature/users/UserFilterForm.vue";
import GroupFilterForm from "@/feature/group-control/GroupFilterForm.vue";
import {ref} from "@vue/runtime-core";
import {useStore} from "vuex";
import {computed} from "@vue/reactivity";
import {useRoute} from "vue-router";
import SmallUsersFilter from "../../feature/users/SmallUsersFilter.vue";
import ReferencesListPage from "@/views/References/ReferencesList.vue";
import ReferenceProfileUserFilterForm from "@/feature/users/ReferenceProfileUserFilterForm.vue";

export default {
  components: {
    ReferenceProfileUserFilterForm,
    ReferencesListPage, SmallUsersFilter, GroupFilterForm, UserFilterForm, SearchOutlined, ReloadOutlined},
    props: {
      header: String,
      type: String,
    },
    setup(props) {
      const store = useStore();
      const route = useRoute();

      const currentFiltersLine = computed(() => props.type === 'group' ?
        store.state.group.filterString :
          store.state.users.filterString);

      const openFilterModal = ref(false);
      const filtersPopoverOpen = ref(false);

      const currentGroupId = computed(() => {
        if (route.name !== "group") return null;
        return route.params.id;
      });

      let resetFilters = () => {
        if (props.type === 'group') {
          store.dispatch('group/clearGroupFilters');
        } else {
          store.dispatch('users/clearUserFilters');
        }
      }

      return {
        currentFiltersLine,
        resetFilters,
        openFilterModal,
        filtersPopoverOpen,
        currentGroupId
      }
    }
  }
</script>

<style scoped lang="scss">
.extended-search-block {
  display: flex;
  align-items: center;
  column-gap: 10px;

  width: 100%;
  flex: 1 1 auto;
  min-width: 0;

  @media (max-width: $mobile-breakpoint) {
    display: none;
  }
}

.extended-search-block__title {
  flex: 0 1 auto;
  min-width: 0;
}

.extended-search-block h2 {
  font-size: 20px;
  font-weight: 600;
  line-height: 120%;
  margin-bottom: 0;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.extended-search-block__search {
  flex: 1 1 150px;
  min-width: 150px;
  max-width: 300px;
}

.header-search-popover {
  width: 100% !important;
}

.extended-search-block__reset {
  flex: 0 0 auto;
  cursor: pointer;
}
</style>